import { DiReact } from "react-icons/di";
import { FaNodeJs, FaCss3Alt, FaHtml5 } from "react-icons/fa";
import { SiExpress, SiMongodb } from "react-icons/si";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { CgFigma } from "react-icons/cg";
import { MdOutlineMail } from "react-icons/md";
import { TbBrandReactNative } from "react-icons/tb";
import { SiAdobexd } from "react-icons/si";
import { FaTelegram } from "react-icons/fa6";
import { ai, crypto, measure, self, project, todo, weather, blogweb, poke } from './assets'
import { IoLogoJavascript } from "react-icons/io5";
import { IoIosApps } from "react-icons/io";
import { SiTailwindcss } from "react-icons/si";



export const menu = [
  { name: "About" },
  { name: "Services" },
  { name: "Skill" },
  { name: "Projects" },
  // {name:"Testimonial"},
  { name: "Contact" },
]



export const projects = [
  {
    id: 1,
    title: 'Infinite AI',
    image: ai,
    category: "AI/ML",
    data: {
      description: `Welcome to Infinite AI, your go-to source for boundless information and assistance. Powered by state-of-the-art language models, Infinite AI is designed to meet your needs with precision and creativity. Whether you need quick answers, innovative ideas, or personalized productivity tips, Infinite AI is here to help. Enjoy engaging and meaningful conversations anytime, anywhere. Experience the future of virtual assistance with Infinite AI and explore the endless possibilities. Your journey to infinite knowledge starts here.`,
      demoLink: "https://ai-infinite.vercel.app/",
    },
    stack: [
      {
        name: "ReactJs",
        icon: <DiReact />,
        iconColor: "skyblue",
      },
      {
        name: "Javascript",
        icon: <IoLogoJavascript />,
        iconColor: "yellow"
      },
      {
        name: "CSS",
        icon: <FaCss3Alt />,
        iconColor: "skyblue",
      },
      {
        name: "API",
        icon: <IoIosApps />,
        iconColor: "skyblue",
      }
    ]
  },
  {
    id: 2,
    title: 'Infinite Crypto',
    image: crypto,
    category: "Web",
    data: {
      description: `Welcome to Infinite Crypto, your comprehensive source for all things cryptocurrency. Powered by cutting-edge technology and real-time data, Infinite Crypto is designed to provide you with accurate insights and analysis. Whether you’re looking for the latest market trends, investment strategies, or educational resources, Infinite Crypto has you covered. Stay informed with up-to-date news, track your portfolio, and explore innovative tools to enhance your crypto journey. Experience the future of digital finance with Infinite Crypto and unlock endless opportunities in the world of cryptocurrency. Your journey to infinite financial potential starts here.`,
      demoLink: "https://infinite-crypto.vercel.app/",
    },
    stack: [
      {
        name: "ReactJs",
        icon: <DiReact />,
        iconColor: "skyblue",
      },
      {
        name: "Javascript",
        icon: <IoLogoJavascript />,
        iconColor: "yellow"
      },
      {
        name: "CSS",
        icon: <FaCss3Alt />,
        iconColor: "skyblue",
      },
      {
        name: "API",
        icon: <IoIosApps />,
        iconColor: "skyblue",
      }
    ]
  },
  {
    id: 3,
    title: 'Pokedéx',
    image: poke,
    category: "Web",
    data: {
      description: `The Pokedex is a web application designed for Pokémon enthusiasts to explore a comprehensive database of Pokémon. Built using React and powered by the PokeAPI, this project fetches real-time data to display detailed information about various Pokémon, including their descriptions and attacksOne of the coolest features I’ve implemented is caching—to optimize performance and minimize API calls, data is stored in local storage. This ensures faster access and a seamless experience for users.`,
      demoLink: "https://pokedecx.vercel.app/",
    },
    stack: [
      {
        name: "Javascript",
        icon: <IoLogoJavascript />,
        iconColor: "yellow"
      },
      {
        name: "Html",
        icon: <FaHtml5 />,
        iconColor: "red",
      },
      {
        name: "CSS",
        icon: <FaCss3Alt />,
        iconColor: "skyblue",
      },
      {
        name: "React",
        icon: <DiReact />,
        iconColor: "skyblue",
      },
      {
        name: "Tailwind",
        icon: <SiTailwindcss />,
        iconColor: "skyblue",
      },
    ]
  },
  {
    id: 4,
    title: 'Measure Distance',
    image: measure,
    category: "Web",
    data: {
      description: ` Distance measurement tool that calculates the distance between two points using latitude and longitude data obtained through GPS. Key Features: Accesses latitude and longitude coordinates directly from GPS data, Utilizes the Euclidean theorem to measure the straight-line distance between points, Enables users to accurately gauge distances over short ranges without relying on any external APIs.`,
      demoLink: "https://measure-distance.netlify.app/",
    },
    stack: [
      {
        name: "Javascript",
        icon: <IoLogoJavascript />,
        iconColor: "yellow"
      },
      {
        name: "Html",
        icon: <FaHtml5 />,
        iconColor: "red",
      },
      {
        name: "CSS",
        icon: <FaCss3Alt />,
        iconColor: "skyblue",
      },
    ]
  },
  {
    id: 5,
    title: 'Nerd Nexus',
    image: blogweb,
    category: "Web",
    data: {
      description: `Nerd Nexus is a vibrant blog website dedicated to the world of technology. It serves as a comprehensive platform for sharing knowledge, insights, and the latest trends in the tech industry. Whether you're a seasoned developer, a budding programmer, or simply a tech enthusiast, Nerd Nexus offers a wealth of information to fuel your passion and curiosity.`,
      demoLink: "https://nerd-nexus.vercel.app/",
    },
    stack: [
      {
        name: "Javascript",
        icon: <IoLogoJavascript />,
        iconColor: "yellow"
      },
      {
        name: "Html",
        icon: <FaHtml5 />,
        iconColor: "red",
      },
      {
        name: "CSS",
        icon: <FaCss3Alt />,
        iconColor: "skyblue",
      },
      {
        name: "React",
        icon: <DiReact />,
        iconColor: "skyblue",
      },
      {
        name: "Tailwind",
        icon: <SiTailwindcss />,
        iconColor: "skyblue",
      },
    ]
  },
  
  {
    id: 6,
    title: 'Self Driving Car',
    image: self,
    category: "AI/ML",
    data: {
      description: `I've been diving deep into the world of autonomous vehicles and decided to create a self-driving car using JavaScript—with no external libraries! Throughout this project, I've gained invaluable skills and knowledge, including:
Implementing car driving mechanics .
Defining and creating the driving environment. 
Simulating sensors to gather real-time data. 
Detecting and handling collisions. 
Developing and training a neural network to control the car autonomously.`,
      demoLink: "https://infinite-self-driving.netlify.app/",
    },
    stack: [
      {
        name: "Javascript",
        icon: <IoLogoJavascript />,
        iconColor: "yellow"
      },
      {
        name: "Html",
        icon: <FaHtml5 />,
        iconColor: "red",
      },
      {
        name: "CSS",
        icon: <FaCss3Alt />,
        iconColor: "skyblue",
      },

    ]
  },
  
]



export const experience = [

  {
    title: "Frontend Development",
    data: [
      {
        skill: "HTML",
        level: "Experienced",
      },
      {
        skill: "CSS",
        level: "Experienced",
      },
      {
        skill: "JavaScript",
        level: "Experienced",
      },
      {
        skill: "Tailwind",
        level: "Intermediate",
      },
      {
        skill: "Bootstrap",
        level: "Experienced",
      },
      {
        skill: "React",
        level: "Experienced",
      },
      {
        skill: "React Native",
        level: "Experienced",
      },
    ]
  },
  {
    title: "Backend Development",
    data: [
      {
        skill: "Node JS",
        level: "Experienced",
      },
      {
        skill: "MongoDB",
        level: "Intermediate",
      },
      {
        skill: "Express.js",
        level: "Intermediate",
      },

      {
        skill: "Python",
        level: "Intermediate",
      },
      {
        skill: "MySQL",
        level: "Experienced",
      },
    ]
  },
  {
    title: "Other Skills",
    data: [
      {
        skill: "Python",
        level: "Intermediate",
      },
      {
        skill: "C++",
        level: "Experienced",
      },
      {
        skill: "Solidity",
        level: "Beginner"
      },
      {
        skill: "Figma",
        level: "Experienced",
      },
      {
        skill: "Sketch",
        level: "Intermediate",
      },
      {
        skill: "XD",
        level: "Intermediate",
      },
    ]
  }
]


export const socialHandles = [
  {
    name: "Email",
    icon: <MdOutlineMail />,
    link: "mailto:mohitkh22@gmail.com",
  },
  {
    name: "Github",
    icon: <AiFillGithub />,
    link: "https://github.com/Mohit-Alive",
  },
  {
    name: "LinkedIn",
    icon: <AiFillLinkedin />,
    link: "https://www.linkedin.com/in/mohit-kholiya/",
  },
  {
    name: "Telegram",
    icon: <FaTelegram />,
    link: "https://t.me/Mohit_100",
  },
];